<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16.667 3.336H3.334a1.667 1.667 0 0 0-1.667 1.667v10a1.667 1.667 0 0 0 1.667 1.666h13.333a1.667 1.667 0 0 0 1.667-1.666v-10a1.667 1.667 0 0 0-1.667-1.667Zm0 3.917L10 11.698 3.334 7.253V5.25L10 9.694l6.667-4.444v2.003Z"
    fill="#111"
    fill-opacity=".64"
  />
</svg>
